import { useState } from 'react'

import { Input } from '@/components/ui/input'

interface SharePercentInputProps {
  name: string
  value: number
  disabled?: boolean
  onCommit: (value: number) => void
}

/** A whole-number percentage applied on Enter or blur, so typing "35" never applies "3" first. */
export function SharePercentInput({ name, value, disabled, onCommit }: SharePercentInputProps) {
  const [text, setText] = useState<string | null>(null)

  function apply() {
    if (text === null) return
    setText(null)
    const next = Number.parseInt(text, 10)
    if (!Number.isNaN(next) && next !== value) onCommit(next)
  }

  return (
    <span className="flex items-center gap-1">
      <Input
        size="sm"
        inputMode="numeric"
        aria-label={`${name} percentage`}
        value={text ?? String(value)}
        disabled={disabled}
        className="w-14 px-2 text-right"
        onChange={(event) => setText(event.target.value.replace(/\D/g, '').slice(0, 3))}
        onBlur={apply}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            apply()
          } else if (event.key === 'Escape') {
            setText(null)
          }
        }}
      />
      <span aria-hidden className="text-muted-foreground text-sm">
        %
      </span>
    </span>
  )
}
